
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Operation } from '../operation/operation';
import { Revision } from '../revision/revision';
import { RevisionService } from '../revision/revision.service';
import { Document } from './document';
import { DocumentService } from './document.service';
import { NotifierService, DialogService } from '../ui';
import { DossierModel } from '../dossier-model/dossier-model';

@Component({
  templateUrl: './document-list.component.html',
})
export class DocumentListComponent implements OnInit {

  operation: Operation
  revision: Revision
  dossierModel: DossierModel

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private documentService: DocumentService,
    private revisionService: RevisionService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    // Get the operation/revision/documents
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.operation = data.operation;
      this.revision = data.operation.revision;

      this.dossierModel = data.dossierModel;

      this.notifier.endProgress();
    });
  }

  private fetch() {
    this.notifier.startProgress();

    this.documentService
      .documents(this.operation.id, this.revision.id).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((operation) => {
        this.operation = operation;
        this.revision = operation.revision;
      });
  }

  view(document: Document, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['operations', this.operation.id, this.revision.id, document.id]);
    }
  }

  delete(document: Document) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer ce document?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.documentService
          .delete(this.operation.id, this.revision.id, document.id)
          .subscribe((id) => {
            this.notifier.success('Document supprimé avec succès');

            this.fetch();

          }, (err) => {
            this.notifier.endProgress();
          });
      });

    return false;
  }

  updateRevision(status: string) {

    let publish = status === 'PRODUCTION';

    this.dialogService
      .confirm({
        title: 'Révision',
        message: `Voulez-vous ${publish ? 'publier' : 'archiver'} cette révision?`,
        confirm_button_text: publish ? 'Publier' : 'Archiver',
        confirm_button_class: 'btn-primary'
      })
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.revisionService
          .update(this.operation.id, this.revision.id, status)
          .subscribe((revision) => {
            this.notifier.success(`Révision ${publish ? 'publiée' : 'archivée'} avec succès`);

            this.fetch();

          }, (err) => {
            this.notifier.endProgress();
          });
      });
  }

  duplicateRevision() {
    this.dialogService
      .confirm({
        title: 'Révision',
        message: `Voulez-vous dupliquer cette révision?`,
        confirm_button_text: 'Dupliquer',
        confirm_button_class: 'btn-primary'
      })
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.revisionService
          .duplicate(this.operation.id, this.revision.id, status)
          .subscribe((revision) => {
            this.notifier.success(`Révision dupliquée avec succès`);

            this.router.navigate(['operations', this.operation.id, revision.id]);

          }, (err) => {
            this.notifier.endProgress();
          });
      });
  }

  deleteRevision() {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer cette révision?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.revisionService
          .delete(this.operation.id, this.revision.id)
          .subscribe((id) => {
            this.notifier.success('Révision supprimée avec succès');

            this.router.navigate(['operations', this.operation.id]);

          }, (err) => {
            this.notifier.endProgress();
          });
      });

    return false;
  }
}
